import { EmptyCard } from "../../components/empty-card";
import { ServiceGrid, ServiceGridSkeleton } from "../../components/service-card";
import { PageTitle, SiteHead } from "../../components/site-head";
import { SitePage } from "../../components/site-page";
import { usePublicDirectory } from "../../hooks/use-public-directory";
import { useSiteConfig } from "../../hooks/use-site-config";
import { HowItWorks } from "../how-it-works/how-it-works";
import { m } from "@/paraglide/messages.js";

/** Every service the trainer has set up for booking, exactly as they set it up. */
export const Services = () => {
  const site = useSiteConfig();
  const { directory, loading } = usePublicDirectory({ days: site.calendarDays });
  const services = directory?.services ?? [];

  return (
    <SitePage
      head={
        <SiteHead>
          <PageTitle title={m.landing_nav_services()} aside={m.services_aside()} />
        </SiteHead>
      }
    >
      {loading ? (
        <ServiceGridSkeleton className="mt-3" />
      ) : directory && services.length > 0 ? (
        <ServiceGrid services={services} directory={directory} lead className="mt-3" />
      ) : (
        <EmptyCard title={m.services_empty_title()} />
      )}
      <HowItWorks />
    </SitePage>
  );
};
